import { FilterProps } from '@common/types/types';

export const statusMap: FilterProps[] = [
  {
    value: 'all',
    label: 'allStatuses',
  },
  {
    value: 'opened',
    label: 'openedStatus.label',
    color: '#1349D5',
    description: 'openedStatus.description',
  },
  {
    value: 'resolved',
    label: 'resolvedStatus.label',
    color: '#5500C2',
    description: 'resolvedStatus.description',
  },
  {
    value: 'closed',
    label: 'closedStatus.label',
    color: '#035E11',
    description: 'closedStatus.description',
  },
  {
    value: 'reopened',
    label: 'reopenedStatus.label',
    color: '#1349D5',
    description: 'reopenedStatus.description',
  },
  {
    value: 'archived',
    label: 'archivedStatus.label',
    color: '#000000A6',
    description: 'archivedStatus.description',
  },
];
